<template>
  <div>
    <div class="home" v-if="visible === true">
      <div class="header-container">
        <div class="survey-logo" v-if="logo != null && logo != ''">
          <img v-bind:src="'data:image/png;base64,' + logo" />
        </div>
        <h1 class="h1-class" v-html="surveyName"></h1>
        <h2 class="h2-class" v-html="sectionName"></h2>
        <h3 class="h3-class" v-html="description"></h3>
      </div>
      <div class="survey-section">
        <questions
          v-for="q in questions"
          :question="q"
          :key="q.q_id"
          :badQuestions="badQuestions"
          :surveyId="surveyId"
          @emit-value-question="emitValueQuestion"
          @emit-value-age="emitValueQuestion"
        ></questions>
        <div class="main-button-survey">
          <div class="main-button-container">
            <md-button
                    v-on:click="clickButtonNext"
                    class="btn-next md-success"
            >
              {{ nextButtonLabel }}
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import surveysService from "@/services/Surveys/surveys";
import Questions from "@/views/Surveys/Question.vue";

export default {
  name: "Home",
  components: {
    Questions
  },
  data: function() {
    return {
      availableSurvey: false,
      inProgressSurvey: false,
      resultId: "",
      surveyId: "",
      surveyName: "",
      description: "",
      sectionName: "",
      section: null,
      message: "",
      status: "",
      questions: [],
      mapQuestions: new Map(),
      questionsWithAsnwer: [],
      visible: false,
      badQuestions: [],
      css: "",
      logo: "",
      nextButtonLabel: "",
      currentSection: 0,
      totalSections: 0,
      customCSS: "",
      canClick: true,
    };
  },
  methods: {
    clickButtonNext: function(){
      if (this.canClick === true) {
        // remove clic operation
        this.canClick = false;
        //clean answers
        this.questionsWithAsnwer = [];
        this.badQuestions = [];
        //fill array of questions with answer
        for (let q of this.mapQuestions.values()) {
          if(q.q_type != "DisplayImage"){
            this.questionsWithAsnwer.push(q);
          }
        }
        //console.log("Click del botón");
        surveysService
          .answerSurvey(this.questionsWithAsnwer, this.section, this.resultId)
          .then(response => {
            console.log(response);
            //survey id
            //this.surveyId = response.data.survey_id;
            //questions
            //this.questions = response.data.questions;
            //survey name
            //this.surveyName = response.data.survey_name;
            //description
            //this.description = response.data.description;
            //section
            //this.section = response.data.section;
            //message
            this.message = response.data.message;
            //status
            this.status = response.data.status;
            //section name
            //this.sectionName = response.data.name;

            if(this.status === "Finished"){
              this.$router.push({
              name: "finished",
                params: {
                  end_message: this.message,
                  survey_name: this.surveyName,
                  logo: this.logo,
                  css: this.css,
                  customCSS: this.customCSS,
                  resultId: this.resultId}});
            }

            else if(this.status === "error" && this.message === "Respuesta incorrecta"){
              this.badQuestions = response.data.bad_questions;
              alert('Por favor revise sus respuestas');
              console.log(this.badQuestions);
            }

            else{
              //next section
              //section name
              this.sectionName = response.data.name;
              //questions
              this.questions = response.data.questions;
              //survey name
              this.surveyName = response.data.survey_name;
              //description
              this.description = response.data.description;

              //currentSection
              this.currentSection = response.data.section;

              //totalSections
              this.totalSections = response.data.total_sections;

              //generate label of next button
              if (this.currentSection == this.totalSections) {
                this.nextButtonLabel = "Finalizar";
              } else {
                this.nextButtonLabel = "Siguiente";
              }

              this.mapQuestions = new Map();

              //fill map of questions
              this.questions.forEach(this.insertQuestionToMap);

              

              console.log(this.mapQuestions);
            }

            
          })
          .catch(e => {
            console.log(e);
            this.$notifyError("Error obteniendo encuesta");
          })
          .finally(e => {this.canClick = true;}); // return click operation
      }
    },
    getSurvey: function() {
      surveysService
        .getSurveyWeb(this.resultId)
        .then(response => {
          console.log(response);
          //survey id
          this.surveyId = response.data.survey_id;
          //questions
          this.questions = response.data.questions;
          //survey name
          this.surveyName = response.data.survey_name;
          //description
          this.description = response.data.description;
          //section
          this.section = response.data.section;
          //message
          this.message = response.data.message;
          //status
          this.status = response.data.status;
          //section name
          this.sectionName = response.data.name;
          //logo
          this.logo = response.data.logo;
          //css
          this.css = response.data.css;
          //custom css
          this.customCSS = response.data.custom_css;

          //currentSection
          this.currentSection = response.data.section;

          //totalSections
          this.totalSections = response.data.total_sections;

          //generate label of next button
          if (this.currentSection == this.totalSections) {
            this.nextButtonLabel = "Finalizar";
          } else {
            this.nextButtonLabel = "Siguiente";
          }

          //fill css with css of the survey
          if(this.css != null && this.css != ''){
            this.appendFile(this.css);
          }
          else{
            let cssNew = "styles-tigo.css";
            this.appendFile(cssNew);
          }

          //fill css with css of the survey
          if(this.customCSS != null && this.customCSS != ''){
            this.overrideStyles(this.customCSS);
          }

          //logo
          if (this.logo == null || this.logo === "") {
            //console.log("Entro al logo");
            this.logo =
              "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";
          }

          //check if there is a survey to answer
          if(this.status === "error" && this.message != null){
            this.$router.push({
            name: "no-survey",
            params: { message: this.message }
            });
            return;
          }

          //fill map of questions
          this.questions.forEach(this.insertQuestionToMap);
          this.visible = true;

          //console.log(this.mapQuestions);
        })
        .catch(e => {
          console.log(e);
          this.$notifyError("Error obteniendo encuesta");
        });
    },
    emitValueQuestion: function(e) {
      //set answer of the question emitted
      this.mapQuestions.get(e.q_id).ans = e.ans;
      //console.log(this.mapQuestions);
    },
    insertQuestionToMap: function(question){
      this.mapQuestions.set(question.q_id, question);
    },
    appendFile: function(css){
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = process.env.VUE_APP_BASE_CLIENT_URL + "/static/" + css;
      document.head.appendChild(file);
      //console.log("Entro a append file");
    },
    overrideStyles: function(customCSS) {
      let style = document.createElement("style");
      style.type = 'text/css';
      style.appendChild(document.createTextNode(customCSS));
      document.head.appendChild(style);
    }
  },
  mounted: function() {
    //this.appendFile(css);
    if(this.$route.query.q != null){
      this.resultId = this.$route.query.q;
      this.getSurvey();
    } else if (this.$route.query.word != null) {
      let word = this.$route.query.word;
      let questionKey = this.$route.query.questionKey;
      //call to open panel survey
      surveysService
        .getSurveyWebOpenPanel(word, questionKey)
        .then(response => {
          //message
          this.message = response.data.message;
          //status
          this.status = response.data.status;

          //check if there is a survey to answer
          if (this.status === "created" && this.message != null) {
            this.$router.push({
              name: "surveys",
              query: { q: this.message }
            });
            return;
          } else {
            this.$router.push({
              name: "no-survey",
              params: { message: this.message }
            });
            return;
          }
        })
        .catch(e => {
          console.log(e);
          this.$notifyError("Error obteniendo encuesta");
        });
    }
    
  }
};
</script>
